import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { UserProvider, useUser } from "@/context/UserContext";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import MapSearch from "@/pages/client/MapSearchV2";
import ClientRequests from "@/pages/client/RequestsV2";
import ClientProfile from "@/pages/client/ProfileV2";
import InterpreterDashboard from "@/pages/interpreter/Dashboard";
import InterpreterProfile from "@/pages/interpreter/ProfileV2";
import Chat from "@/pages/Chat";
import "@/App.css";

function DeafEventsRedirect() {
  // The static DeafEvents bundle lives at /deaf-events/index.html. In production
  // the SPA-fallback swallows /deaf-events/<path> (no directory-index resolution),
  // so we force a hard navigation to the actual static file while preserving the
  // sub-path (e.g. /deaf-events/map) via the hash so the inner router can restore it.
  useEffect(() => {
    const rest = window.location.pathname.replace(/^\/deaf-events\/?/, "");
    const subHash = rest ? "#__subpath=/" + rest.replace(/\/$/, "") : "";
    const target = "/deaf-events/index.html" + window.location.search + (window.location.hash || subHash);
    window.location.replace(target);
  }, []);
  return null;
}

function PrivateRoute({ children, role }) {
  const { user } = useUser();
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.user_type !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/kunde/suche" element={<PrivateRoute role="client"><MapSearch /></PrivateRoute>} />
          <Route path="/kunde/anfragen" element={<PrivateRoute role="client"><ClientRequests /></PrivateRoute>} />
          <Route path="/kunde/profil" element={<PrivateRoute role="client"><ClientProfile /></PrivateRoute>} />
          <Route path="/dolmetscher/dashboard" element={<PrivateRoute role="interpreter"><InterpreterDashboard /></PrivateRoute>} />
          <Route path="/dolmetscher/profil" element={<PrivateRoute role="interpreter"><InterpreterProfile /></PrivateRoute>} />
          <Route path="/chat/:requestId" element={<PrivateRoute><Chat /></PrivateRoute>} />
          <Route path="/deaf-events" element={<DeafEventsRedirect />} />
          <Route path="/deaf-events/*" element={<DeafEventsRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
}

export default App;
